export var pi = Math.PI;
export var tau = 2 * Math.PI;
export var e = Math.E;
export var phi = 1.61803398874989484820458683436563811772030917980576286213545;